import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ROUTES } from '@solarwindscloud/sso-nighthawk-shared';
import styles from './SamlLogin.module.scss';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { DocumentTitle, EmailInput, ErrorMessage, SubmitButton, LinkedButton } from '../../components';
import { Form, Grid, Divider } from '@solarwindscloud/nighthawk-ui';
import { getEmailFromLocationSearch } from '../Login/form/demoUsers';
import { samlRedirect } from '../../api/actions';
import { redirectTo } from '../../utils/utils';

export const SamlLogin = () => {
  const SamlLoginWithRouter = withRouter(SamlLoginForm);
  return (
    <DocumentTitle title={'SolarWinds Cloud'}>
      <UnifiedLayout headerText="Single Sign On Login" dataTestPageName="saml-login">
        <SamlLoginWithRouter />
      </UnifiedLayout>
    </DocumentTitle>
  );
};

function SamlLoginForm(props) {
  const defaultEmail = getEmailFromLocationSearch(props.location.search) || '';
  const [email, setEmail] = useState(defaultEmail);
  const [emailError, setEmailError] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Form
        className={styles.samlLoginForm}
        onSubmit={loginWithSaml}
        method="POST"
        error={!isFormValid() || !isLoginValid()}
        data-test-saml-login-form
      >
        <Grid padded verticalAlign="middle">
          <Grid.Column width={12}>
            {renderEmailInput()}
            <Divider hidden />

            {renderLoginButton()}
            {renderBackLink()}
          </Grid.Column>
        </Grid>
      </Form>
      <Divider hidden section />

      <div className={styles.messageContainer}>
        {!isLoginValid() && <ErrorMessage message={loginError} renderCloseMessage />}
      </div>
    </>
  );

  function renderEmailInput() {
    return (
      <EmailInput
        onChange={handleChangeEmail}
        onError={handleEmailError}
        hasError={!!emailError}
        value={email}
        autoFocus
        placeholder={'Email address for SSO'}
        allowEmpty
      />
    );
  }

  function renderLoginButton() {
    return (
      <SubmitButton className={styles.loginButton} disabled={isLoginDisabled()} loading={loading}>
        Log in with SSO
      </SubmitButton>
    );
  }

  function renderBackLink() {
    return <LinkedButton link={ROUTES.LOGIN} label="Return to Login" />;
  }

  function handleChangeEmail(value) {
    setEmailError('');
    setEmail(value);
  }

  function handleEmailError(error) {
    setEmailError(error);
  }

  function isFormValid() {
    return emailError.length === 0 && email.length > 0;
  }

  function isLoginValid() {
    return !loginError;
  }

  function isLoginDisabled() {
    return !isFormValid();
  }

  async function loginWithSaml() {
    try {
      setLoading(true);
      const redirectUri = await samlRedirect(email);
      redirectTo(redirectUri);
    } catch (e) {
      setLoading(false);
      setLoginError(e.message);
    }
  }
}
